import SurveyButton from "./SurveyButton";

/**
 * Button for the survey results page.
 * @param {object} props
 * @param {{ buttonBackgroundColor: string; buttonTextColor: string; }} props.colorTheme The theme for the button.
 * @param {boolean} props.loading `true` to display a loader instead of the button content. Defaults to `false`.
 * @param {boolean} props.disabled `true` to disable the button. Defaults to `false`.
 * @param {string} props.href Link for the button. An `<a>` tag is rendered instead of a `<button>` tag when this prop is provided.
 * @param {React.MouseEventHandler<HTMLButtonElement> | undefined} props.handleOnClick Handler for the button click event.
 * @param {React.ReactNode} props.children Content for the button.
 */
function SurveyResultsButton({ colorTheme, loading = false, disabled = false, handleOnClick, href, children, ...props }) {
    return (
        <SurveyButton
            size={{fontSize: "14pt", paddingX: "14px", paddingY: "7px"}}
            colorTheme={colorTheme}
            loading={loading}
            disabled={disabled}
            handleOnClick={handleOnClick}
            href={href}
            {...props}
        >
            {children}
        </SurveyButton>
    );
}

export default SurveyResultsButton;
